(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ob-shop-colours"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var bar = root.querySelector('[data-obs-sticky]');
      if (!bar || !('IntersectionObserver' in window)) return;
      var hero = document.getElementById('ob-hero');
      var shop = root.querySelector('.obs__inner');
      var heroOut = !hero, shopIn = false;
      function update() { bar.hidden = !(heroOut && !shopIn); }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === hero) heroOut = !en.isIntersecting;
          if (en.target === shop) shopIn = en.isIntersecting;
        });
        update();
      });
      if (hero) io.observe(hero);
      io.observe(shop);
    }
    document.querySelectorAll('.obs').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.obs').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-styling-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setPlayState(card, playing) {
      var btn = card.querySelector('[data-obv-play]');
      if (!btn) return;
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      card.classList.toggle('is-paused', !playing);
    }

    function init(root) {
      var rail = root.querySelector('[data-obv-rail]');
      if (!rail || rail.dataset.obvReady) return;
      rail.dataset.obvReady = '1';
      var videos = Array.prototype.slice.call(rail.querySelectorAll('[data-obv-video]'));

      videos.forEach(function (v) {
        var card = v.closest('.obv__card');
        v.dataset.userPaused = reduce ? '1' : '';
        setPlayState(card, false);

        card.querySelector('[data-obv-play]').addEventListener('click', function () {
          if (v.paused) {
            v.dataset.userPaused = '';
            v.play().catch(function () {});
            setPlayState(card, true);
          } else {
            v.dataset.userPaused = '1';
            v.pause();
            setPlayState(card, false);
          }
        });

        card.querySelector('[data-obv-sound]').addEventListener('click', function (e) {
          var btn = e.currentTarget;
          var turnOn = v.muted;
          videos.forEach(function (o) {
            o.muted = true;
            var b = o.closest('.obv__card').querySelector('[data-obv-sound]');
            b.setAttribute('aria-pressed', 'false');
            b.setAttribute('aria-label', 'Turn sound on');
          });
          if (turnOn) {
            v.muted = false;
            btn.setAttribute('aria-pressed', 'true');
            btn.setAttribute('aria-label', 'Turn sound off');
            if (v.paused) { v.dataset.userPaused = ''; v.play().catch(function () {}); setPlayState(card, true); }
          }
        });
      });

      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          var card = v.closest('.obv__card');
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            if (v.dataset.userPaused) return;
            v.preload = 'auto';
            v.play().then(function () { setPlayState(card, true); }).catch(function () {});
          } else if (!v.paused) {
            v.pause();
            setPlayState(card, false);
          }
        });
      }, { threshold: [0, 0.6] });
      videos.forEach(function (v) { io.observe(v); });
    }

    document.querySelectorAll('.obv').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.obv').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-voices"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOkendo() {
      if (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function') {
        window.okeWidgetApi.initAllWidgets();
      }
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.obq [data-oke-widget]')) initOkendo();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
